<template>
  <div class="borrow-manage-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('borrowManage.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0" @click="_moreCondition">
          {{ borrowManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="borrowManageInfo.conditions.borrowId"
            :placeholder="$t('borrowManage.search.borrowId')" clearable />
        </el-col>
        <el-col :span="8">
          <el-input v-model="borrowManageInfo.conditions.title" :placeholder="$t('borrowManage.search.title')"
            clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="borrowManageInfo.conditions.typeCd" :placeholder="$t('borrowManage.search.typeCd')"
            style="width:100%">
            <el-option v-for="item in borrowManageInfo.typeCds" :key="item.typeCd" :label="item.typeName"
              :value="item.typeCd" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryBorrowsMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetBorrowsMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
      <el-row v-if="borrowManageInfo.moreCondition" :gutter="20" style="margin-top:15px">
        <el-col :span="6">
          <el-input v-model="borrowManageInfo.conditions.staffName"
            :placeholder="$t('borrowManage.search.staffName')" clearable />
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('borrowManage.list.title') }}</span>
        <el-button type="primary" size="small" @click="_openAddBorrowModal">
          <i class="el-icon-plus"></i>
          {{ $t('common.add') }}
        </el-button>
      </div>
      <el-table :data="borrowManageInfo.borrows" border style="width: 100%">
        <el-table-column prop="borrowId" :label="$t('borrowManage.table.borrowId')" align="center" />
        <el-table-column prop="title" :label="$t('borrowManage.table.title')" align="center" />
        <el-table-column prop="typeCdName" :label="$t('borrowManage.table.typeCd')" align="center" />
        <el-table-column prop="quantity" :label="$t('borrowManage.table.quantity')" align="center" />
        <el-table-column prop="unitPrice" :label="$t('borrowManage.table.unitPrice')" align="center" />
        <el-table-column prop="location" :label="$t('borrowManage.table.location')" align="center" />
        <el-table-column prop="userName" :label="$t('borrowManage.table.userName')" align="center" />
        <el-table-column :label="$t('common.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditBorrowModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteBorrowModel(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top:20px;text-align:right" />
    </el-card>

    <add-borrow-view ref="addBorrowView" @success="handleSuccess" />
    <edit-borrow-view ref="editBorrowView" @success="handleSuccess" />
    <delete-borrow ref="deleteBorrow" @success="handleSuccess" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listBorrows, listBorrowTypes } from '@/api/oa/borrowManageApi'
import AddBorrowView from '@/components/oa/addBorrowView'
import EditBorrowView from '@/components/oa/editBorrowView'
import DeleteBorrow from '@/components/oa/deleteBorrow'

export default {
  name: 'BorrowManageList',
  components: {
    AddBorrowView,
    EditBorrowView,
    DeleteBorrow
  },
  data() {
    return {
      borrowManageInfo: {
        borrows: [],
        total: 0,
        records: 1,
        moreCondition: false,
        title: '',
        typeCds: [],
        conditions: {
          title: '',
          typeCd: '',
          staffName: '',
          borrowId: '',
          page: 1,
          row: 10,
          communityId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.borrowManageInfo.conditions.communityId = this.communityId
    this._listBorrows()
    this._loadBorrowTypes()
  },
  methods: {
    async _listBorrows() {
      try {
        const params = {
          ...this.borrowManageInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { borrows, total } = await listBorrows(params)
        this.borrowManageInfo.borrows = borrows
        this.page.total = total
      } catch (error) {
        console.error('获取借用列表失败:', error)
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    async _loadBorrowTypes() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: this.communityId
        }
        const { data } = await listBorrowTypes(params)
        this.borrowManageInfo.typeCds = data
      } catch (error) {
        console.error('获取借用类型失败:', error)
      }
    },
    _openAddBorrowModal() {
      this.$refs.addBorrowView.open()
    },
    _openEditBorrowModel(row) {
      this.$refs.editBorrowView.open(row)
    },
    _openDeleteBorrowModel(row) {
      this.$refs.deleteBorrow.open(row)
    },
    _queryBorrowsMethod() {
      this.page.current = 1
      this._listBorrows()
    },
    _resetBorrowsMethod() {
      this.borrowManageInfo.conditions = {
        title: '',
        typeCd: '',
        staffName: '',
        borrowId: '',
        page: 1,
        row: 10,
        communityId: this.communityId
      }
      this._listBorrows()
    },
    _moreCondition() {
      this.borrowManageInfo.moreCondition = !this.borrowManageInfo.moreCondition
    },
    handleSuccess() {
      this._listBorrows()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listBorrows()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listBorrows()
    }
  }
}
</script>

<style lang="scss" scoped>
.borrow-manage-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .no_display {
    display: none;
  }
}
</style>